import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
} from "@ionic/react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  AlertTitle,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  FormLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import React, { useState } from "react";
import { useParams } from "react-router";
import { baseUrl, config, requestID } from "../../common/utils";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

export type User = {
  accountName: string;
  accountNumber: number;
  activeloans: number;
  area: string;
  bankName: string;
  businessAddress: string;
  bvn: number;
  churchAddress: string;
  dob: string; // Date of birth as a string
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  lga: string;
  middleName: string;
  nextOfKin: string;
  nextOfKinAddress: string;
  nextOfKinPhone: string;
  nextOfKinRelationship: string;
  parish: string;
  password: string; // This should not be displayed or handled in the UI
  pastorName: string;
  pastorPhone: string;
  phone: string;
  province: string;
  residentialAddress: string;
  savingAmount: string;
  securityAnswer1: string;
  securityAnswer2: string;
  securityQuestion1: string;
  securityQuestion2: string;
  status: number;
  titles: string;
  unitHeadName: string;
  unitHeadPhone: string;
  user_id: string;
  zone: string;
};

const schema = yup
  .object({
    reason: yup.string().required("Reason is required."),
    otherReason: yup
      .string()
      .when("reason", {
        is: (value:string)=>value == "other", 
        then: (schema) =>  schema.required("Please specify the reason."),
        otherwise :(schema)=>schema.nullable()
      }),
  })
  .required();

const MemberWithdrawal = () => {


  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })




  const { name } = useParams<{ name: string }>();
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<any>(null);

  const [reason, setReason] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [status, setStatus] = useState({ loading: false, error: false });

  const handleSearch = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("searchTerm", searchTerm);

      const response = await axios.post(
        `${baseUrl()}users/searchUser`,
        formData,
        config
      );

      const { data } = response.data;
      console.log(data);
      const fetchedResults = data;
      setResults(fetchedResults);
    } catch (error) {
      console.error(error);
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };


  const handleConfirmClosure = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("user_id", results?.user_id);
      formData.append("reason", reason == "other" ? otherReason : reason);
      const response = await axios.post(
        baseUrl() + "users/applyForClosure",
        formData,
        config
      );
      console.log(response.data);
      if (response.data.status === true) {
        setAlertMsg(response.data.message);
        onShowAlert();
        setReason("");
        setResults(null);
        setSearchTerm("");
        setOpenDialog(false);

        setStatus({ loading: false, error: false });
      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setOpenDialog(false);
        setReason("");
        setResults(null);
        setSearchTerm("");
        setOpenDialog(false);
        reset()
        setStatus({ loading: false, error: true });
      }
    } catch (error) {
      setStatus({ loading: true, error: false });
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Container component="main" maxWidth="md" sx={{ mt: 8, mb: 2 }}>
          {/* <Box sx={{ m: 1 }}>
            <Link to="/folder/MemberWithdrawalList/MemberWithdrawalList">
              <Button>view withdrawal list</Button>
            </Link>{" "}
          </Box> */}

          <Paper elevation={3} sx={{ padding: 3 }}>
            {showAlert && (
              <Alert severity={status.error ? "error" : "success"}>
                <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
                {alertMsg?.toUpperCase()}
              </Alert>
            )}
            <Typography variant="h5" component="h1" gutterBottom>
              Search User
            </Typography>
            <form onSubmit={handleSearch}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Search by Email or Phone"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                required
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                {status.loading ? <CircularProgress /> : "Submit"}
              </Button>
            </form>
            {results && results ? (
              <>
                <List sx={{ mt: 3 }}>
                  <ListItem>
                    <ListItemText
                      primary={`Name: ${results.firstName} ${results.middleName} ${results.lastName}`}
                      secondary={`Phone: ${results.phone}`}
                    />
                  </ListItem>
                </List>
                <Box sx={{ mt: 3 }}>
                  <Typography variant="h6" component="h2" gutterBottom>
                    Additional Information
                  </Typography>
                  <FormControl fullWidth margin="normal">
                    <InputLabel id="reason-label">
                      Reason for Closure
                    </InputLabel>
                    <Select
                  error={!!errors.reason}
                  {...register("reason")}
                      labelId="reason-label"
                      value={reason}
                    
                      onChange={(e) => setReason(e.target.value)}
                      label="Reason for Closure"
                      
                    >
                      <MenuItem value="privacy">Privacy concerns</MenuItem>
                      <MenuItem value="security">Security issues</MenuItem>
                      <MenuItem value="death"> Death of Member</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </Select>
                    <Typography color="error">{errors.reason?.message}</Typography>
                  </FormControl>
               

                  {reason === "other" && (
                    <TextField
                      required
                      fullWidth
                      label="Specify Reason"
                      margin="normal"
                      value={otherReason}
                      onChange={(e) => setOtherReason(e.target.value)}
                      // {...register("otherReason")}
                      // error={!!errors.otherReason}
                      // helperText={errors.otherReason?.message}
                    />

                 
                  )}

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit(handleOpenDialog)}
                    sx={{ mt: 2 }}
                  >
                    Submit Request
                  </Button>
                </Box>
              </>
            ) : (
              <List sx={{ mt: 3 }}>
                <ListItem>
                  <ListItemText>No User found</ListItemText>
                </ListItem>
              </List>
            )}
          </Paper>
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="confirmation-dialog-title"
          >
            <DialogTitle id="confirmation-dialog-title">
              Confirm Request
            </DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to close the account for{" "}
                {results?.firstName} {results?.lastName}? This action cannot be
                undone.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="primary">
                Cancel
              </Button>
              <Button onClick={handleConfirmClosure} color="secondary">
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default MemberWithdrawal;
